import { selectedTimeAtom } from "@/api/atoms";
import { useMediaQuery } from "@react-hookz/web";
import { AnimatePresence } from "framer-motion";
import { useAtomValue } from "jotai";
import { Suspense } from "react";

import { AdCard } from "./AdCard";
import { AreasCard } from "./AreasCard";
import { CardList } from "./CardList";
import { Chart } from "./Chart";
import { Spinner } from "./Spinner";
import { TimeDropdown } from "./TimeDropdown";

interface InfoCardProps {
  title: string;
}

export function InfoCard(props: InfoCardProps) {
  const isMobileDevice = useMediaQuery("(max-device-width: 480px)");
  const selectedTime = useAtomValue(selectedTimeAtom);

  const title = isMobileDevice ? props.title.replace(" -", "") : props.title;

  return (
    <div className="rounded md:w-[420px] md:bg-gray-600 md:bg-opacity-80 md:p-5">
      <div className="flex w-full items-center justify-between">
        <h1 className="font-display text-[42px] leading-8 text-white">{title}</h1>
        <TimeDropdown />
      </div>
      <p className="mt-1 text-xs text-gray-400">
        Bike thefts in{" "}
        {selectedTime === 1
          ? "2020"
          : selectedTime === 2
            ? "2021"
            : selectedTime === 3
              ? "2022"
              : selectedTime === 4
                ? "2023"
                : selectedTime === 5
                  ? "2024"
                  : selectedTime === 6
                    ? "2025"
                    : "December 2025"}
      </p>
      <div className="mt-5 flex w-full flex-wrap items-center justify-center gap-5 md:mb-5">
        <AnimatePresence>
          <CardList />
        </AnimatePresence>
      </div>
      {isMobileDevice && <hr />}
      {isMobileDevice && <AreasCard />}
      {isMobileDevice && <hr />}
      <Suspense fallback={<Spinner />}>
        <Chart />
      </Suspense>
      {isMobileDevice && <hr />}
      <AdCard />
    </div>
  );
}
